module.exports = __webpack_public_path__ + "img/unissued-account.fa7bef18.svg";